import {
    setState,
    STATE_INIT_STATE_KEY,
    STATE_INIT_FAILED_STATE_KEY,
} from '~shared/utils/state';
import { post } from '~shared/utils/http';
import { buildSpectateUrl } from './Spectate';
import { createWsInterface } from './Websockets';
import { processClientSettings } from './WrapperIntegration/ClientSettings';
import {
    getRegulationTypeId,
    getProductPackageId,
    getLanguageCode,
    getSubBrandId,
    getBrandId,
    getTimezone,
    getCountryIso,
    getUserMode,
    getCurrencyIso,
    getUserDevice,
    getCountryState,
    getCurrentTheme,
    getWrapperPageCorrelationId,
} from '~shared/utils/user';
import { getClientTimezone } from '~shared/utils/bootstrap-timezone';
import initPolyfills from '~shared/utils/polyfills';
import i18n from '~shared/utils/i18n';
import { loadAliases } from '~shared/utils/uriAliases';
import { kickUser } from '~spa/Utils/WrapperIntegration/Ucf';
import { getClientBuildHash } from '~spa/Utils/BuildInfo';
import { initHeartBeat } from './Heartbeat';

const STATE_ENDPOINT_URL = '/load/state';
const KICK_USER_FLAG = 'customer:out_of_sync:kick';

export const initProxy = async (clientSettings) => {
    await initPolyfills();
    processClientSettings(clientSettings);

    await Promise.all([
        i18n.initialise(),
        loadAliases(),
        loadState(),
    ])
    .then(() => {
        setState(STATE_INIT_STATE_KEY, true);
        initHeartBeat();
    })
    .catch((e) => {
        console.error(e); //eslint-disable-line
        setState(STATE_INIT_FAILED_STATE_KEY, e);
    });
};

const loadState = async () => {
    const requestParams = {
        currency_code: getCurrencyIso(),
        language: getLanguageCode(),
        sub_brand_id: getSubBrandId(),
        brand_id: getBrandId(),
        regulation_type_id: getRegulationTypeId(),
        timezone: getTimezone(),
        browsing_country_code: getCountryIso(),
        product_package_id: getProductPackageId(),
        user_mode: getUserMode(),
        spectate_timezone: getClientTimezone(),
        device: getUserDevice(),
        region: getCountryState(),
        theme_mode: getCurrentTheme(),
        build_hash: getClientBuildHash(),
        page_correlation_id: getWrapperPageCorrelationId(),
    };
    const url = `${buildSpectateUrl(STATE_ENDPOINT_URL)}`;
    const response = await post(url, requestParams);
    const result = await response.json();

    if (response.ok) {

        if (KICK_USER_FLAG in result) {
            if (result[KICK_USER_FLAG] === true) {
                kickUser();
            }

            // Do not store kick flag in State.
            delete result[KICK_USER_FLAG];
        }

        Object.entries(result).forEach(
            ([key, value]) => setState(key, value)
        );

        createWsInterface();

        return Promise.resolve();
    }

    return Promise.reject(result);
};
